module.exports = __webpack_public_path__ + "static/media/paws.14ff00ce.png";